
import getDocumentFormats from "./masters/document_format";
import getTemplateDataType from "./masters/template_data_type";
import getProcessTagType from "./masters/document_tag_type"

export default {
    getDocumentFormats : getDocumentFormats,
    getTemplateDataType : getTemplateDataType,
    getProcessTagType : getProcessTagType
}